import { createAction } from '@reduxjs/toolkit'
import { Layout } from 'react-grid-layout'

import {
    Dashboard,
    DashboardEditableInformation,
    DashboardTab,
    ScheduledExport,
    Widget,
} from 'types'

const NAMESPACE = 'DASHBOARD_PAGE'

// add widget
export const addWidget = createAction<Widget>(`${NAMESPACE}/ADD_WIDGET`)

// delete widget
export const deleteWidget = createAction<{ tabId: string; widgetId: string }>(
    `${NAMESPACE}/DELETE_WIDGET`
)

// update widget
export const updateWidget = createAction<Widget>(`${NAMESPACE}/UPDATE_WIDGET`)

// clone widget
export const cloneWidget = createAction<{
    tabId?: string
    widgetId: string
}>(`${NAMESPACE}/CLONE_WIDGET`)

// toggle widget form modal
export const toggleWidgetModal = createAction(
    `${NAMESPACE}/TOGGLE_WIDGET_MODAL`
)

// update tabs
export const updateTabs = createAction<Partial<DashboardTab>[]>(
    `${NAMESPACE}/UPDATE_TABS`
)

// save dashboard
export const saveDashboardRequest = createAction(
    `${NAMESPACE}/SAVE_DASHBOARD_REQUEST`
)
export const saveDashboardSuccess = createAction<Dashboard>(
    `${NAMESPACE}/SAVE_DASHBOARD_SUCCESS`
)
export const saveDashboardFailure = createAction<{ message: string }>(
    `${NAMESPACE}/SAVE_DASHBOARD_FAILURE`
)

// handle dashboard field change
export const handleFieldsChange = createAction<
    DashboardEditableInformation & { markAsDirty?: boolean }
>(`${NAMESPACE}/HANDLE_FIELDS_CHANGE`)

// change layout
export const changeLayout = createAction<Layout[]>(`${NAMESPACE}/CHANGE_LAYOUT`)

// scheduled exports
export const fetchScheduledExportsSuccess = createAction<{
    results: ScheduledExport[]
}>(`${NAMESPACE}/FETCH_SCHEDULED_EXPORTS_SUCCESS`)

export const shareDashboardRequest = createAction(
    `${NAMESPACE}/SHARE_DASHBOARD_REQUEST`
)

export const shareDashboardSuccess = createAction(
    `${NAMESPACE}/SHARE_DASHBOARD_SUCCESS`
)

export const shareDashboardFailure = createAction<{ message: string }>(
    `${NAMESPACE}/SHARE_DASHBOARD_FAILURE`
)

// currency settings
export const changeDashboardCurrencyCode = createAction<string | null>(
    `${NAMESPACE}/CHANGE_DASHBOARD_CURRENCY_CODE`
)
